import { useEffect, useState } from 'react';

import { Stack } from '@mui/material';
import { LocalPhoneOutlined } from '@mui/icons-material';
import { usePathname } from 'next/navigation';

import { useAppContext, useFacilityContext } from '@/context';
import { getReasonForVisit } from '@/utils/getReasonForVisit/getReasonForVisit';

import CustomButton from './UI/Button/CustomButton';
import { headerStyles } from './Header.styles';
import { getScheduleAppointmentUrl } from './getScheduleAppointmentUrl';

interface MobileFooterActionsProps {
	phoneNumber: string;
	onScheduleClick: (scheduleUrl: string, linkText: string) => void;
}

const MobileFooterActions = ({ phoneNumber, onScheduleClick }: MobileFooterActionsProps) => {
	const [origin, setOrigin] = useState('');

	const { config } = useAppContext();
	const { officeInfo: selectedOffice } = useFacilityContext();
	const pathname = usePathname();

	useEffect(() => {
		if (globalThis.window !== undefined) {
			setOrigin(globalThis.window.location.origin);
		}
	}, []);

	const scheduleAppointmentUrl = getScheduleAppointmentUrl({
		config,
		origin,
		selectedOffice,
		getReasonForVisit: () => getReasonForVisit(pathname),
	});

	return (
		<Stack
			direction="row"
			spacing={1}
			alignItems="center"
			justifyContent="center"
			sx={headerStyles.mobileFooter}
			id="mobile-footer-actions"
		>
			<CustomButton
				variantType="primaryDefault"
				size="small"
				href={scheduleAppointmentUrl}
				onClick={() => onScheduleClick(scheduleAppointmentUrl, 'Schedule')}
			>
				Schedule
			</CustomButton>

			<CustomButton
				variantType="secondary"
				size="small"
				startIcon={<LocalPhoneOutlined />}
				href={`tel:${phoneNumber}`}
				className="InvocaNumber"
				id="mobile-footer-phone-button"
				aria-label={`Call ${phoneNumber}`}
			>
				{phoneNumber}
			</CustomButton>
		</Stack>
	);
};

export default MobileFooterActions;
